import ApiService from './ApiService';

/**
 * @returns {Promise<Array<{id:string,nombre:string,slug:string,activa?:boolean}>>}
 */
export const obtenerCategorias = async ({ todas = false } = {}) => {
  const q = todas ? '?todas=1' : '';
  const res = await ApiService.get(`/categorias${q}`, { withAuth: false });
  return Array.isArray(res?.data) ? res.data : [];
};

/**
 * @param {string} nombre
 */
export const crearCategoria = async (nombre) => {
  const res = await ApiService.post('/categorias', { nombre }, { withAuth: true });
  return res?.data || null;
};

/**
 * @param {string} id
 * @param {{ nombre?: string, activa?: boolean }} data
 */
export const actualizarCategoria = async (id, data) => {
  const res = await ApiService.put(`/categorias/${encodeURIComponent(id)}`, data, {
    withAuth: true,
  });
  return res?.data || null;
};

/**
 * Soft-delete
 * @param {string} id
 */
export const eliminarCategoria = async (id) => {
  await ApiService.del(`/categorias/${encodeURIComponent(id)}`, { withAuth: true });
};
